import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from '../ui/dialog';
import { AlertTriangle } from 'lucide-react';

const TONE = { alta: 'bg-red-500/20 text-red-300 border-red-500/40', media: 'bg-amber-500/20 text-amber-300 border-amber-500/40' };

export const UrgentDocsCard = () => {
  const { api } = useAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => { api.get('/crm/urgent-documents').then((r) => setData(r.data)).catch(() => setData({ alta: 0, media: 0, documents: [] })); }, [api]);
  if (!data) return null;

  return (
    <>
      <button data-testid="dashboard-urgent-docs" onClick={() => setOpen(true)}
        className="inline-flex items-center gap-2 self-start md:self-center rounded-full border border-red-500/40 px-4 py-2 text-sm font-semibold text-red-300 hover:bg-red-500/10 transition-colors">
        <AlertTriangle className="w-4 h-4" />
        <span data-testid="dashboard-urgent-count">{data.alta}</span> urgentes
        <span className="text-amber-300 font-normal">· {data.media} media</span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="urgent-docs-dialog" className="bg-slate-950 border-slate-700 text-white max-w-2xl max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle className="text-white">Documentos urgentes</DialogTitle>
            <DialogDescription className="text-slate-400">Urgencia alta y media de todos tus casos</DialogDescription>
          </DialogHeader>
          {data.documents.length === 0 && <p className="text-sm text-slate-500">No hay documentos urgentes. Los documentos se clasifican al importarlos o al abrir «Documentos por urgencia» en cada caso.</p>}
          <ul className="space-y-2">
            {data.documents.map((d, i) => (
              <li key={i}>
                <button data-testid={`urgent-doc-${i}`} onClick={() => navigate('/crm')} className="w-full text-left bg-slate-900 border border-slate-800 hover:border-slate-600 rounded-xl p-3">
                  <div className="flex items-start justify-between gap-3">
                    <div className="min-w-0">
                      <p className="text-sm font-semibold truncate">{d.filename}</p>
                      <p className="text-xs text-slate-400 truncate">{d.matter_title}</p>
                    </div>
                    <span className={`text-[11px] border rounded-full px-2 py-0.5 shrink-0 ${TONE[d.urgency]}`}>Urgencia {d.urgency}</span>
                  </div>
                  {d.resumen && <p className="text-xs text-slate-500 mt-1 line-clamp-2">{d.resumen}</p>}
                </button>
              </li>
            ))}
          </ul>
        </DialogContent>
      </Dialog>
    </>
  );
};
